import "./GameShared.css";

export default function GameProgress({ label, current, total, progress }) {
  return (
    <div className="game-progress">
      <div>
        {label} {current} de {total}
      </div>

      <div className="game-progress-bar">
        <span style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}